import React from "react";
import { __ } from "@wordpress/i18n";
import { ReviewItem } from "./review-item";
import { GoogleIcon, ReviewsIcon, TrustPilotIcon } from "../../icons";
import { getUtmUrl } from "../../utils/utm-url";

const REVIEW_ITEMS = [
  {
    link: "https://www.trustpilot.com/review/wpmudev.com",
    logo: TrustPilotIcon,
    ratings: __("4.9/5", "plugin-cross-sell-textdomain"),
    reviews: __("3,002", "plugin-cross-sell-textdomain"),
  },
  {
    link: "https://www.reviews.io/company-reviews/store/wpmudev-com/",
    logo: ReviewsIcon,
    ratings: __("4.9/5", "plugin-cross-sell-textdomain"),
    reviews: __("1,746", "plugin-cross-sell-textdomain"),
  },
  {
    link: "https://www.google.com/search?q=WPMU+DEV&stick=H4sIAAAAAAAA_-NgU1I1qLAwMzFJTkq0SLY0NDdNMjW0MqgwNk4ySbZMSjQxTjEwNbAwXsTKER7gG6rg4hoGAFY8Y0Y0AAAA&hl=en&mat=CdvqvSC1kKDMElYBNqvzOh6WSjS1JTPgbDKr_wHsjlg-PedU9JwdPCfoAnD-gp_c4yhRTs4ampJofZFKWPiClgM5THRDw4IjNwi1icSMk7AHlnFbFP31PhpLbvH6V0UYHg&authuser=0#lrd=0x8644cba8c9175b51:0x33b4c9ba43d05083,1,,,",
    logo: GoogleIcon,
    ratings: __("5/5", "plugin-cross-sell-textdomain"),
    reviews: __("592", "plugin-cross-sell-textdomain"),
  },
];

const Footer = () => {
  return (
    <div className="cross-sell-footer">
      <div className="cross-sell-wrapper cross-sell-footer__wrapper">
        <div className="cross-sell-footer__content">
          <div className="cross-sell-footer__title">
            <h2>{__("About WPMU DEV", "plugin-cross-sell-textdomain")}</h2>
            <p>
              {__(
                "Made for web developers, by web developers",
                "plugin-cross-sell-textdomain"
              )}
            </p>
          </div>
          <div className="cross-sell-footer__description">
            <p>
              {__(
                "Since 2006, our award-winning WordPress plugins, hosting, world beating support and site management tools have helped hundreds of thousands of web developers, freelancers and agencies run and grow their businesses. ",
                "plugin-cross-sell-textdomain"
              )}
              <a
                href={getUtmUrl("https://wpmudev.com/about/", {utm_campaign:'cross-sell_learn-more'})}
                target="_blank"
                className="cross-sell-link"
              >
                {__("Learn more", "plugin-cross-sell-textdomain")}
              </a>
            </p>
          </div>
        </div>
        {REVIEW_ITEMS && (
          <div className="cross-sell-footer__reviews">
            {REVIEW_ITEMS.map((item, index) => (
              <ReviewItem key={index} {...item} />
            ))}
          </div>
        )}
        <div className="cross-sell-footer__credits">
          <p>
            {__(
              "Everything Wordpress found in one place. ",
              "plugin-cross-sell-textdomain"
            )}
            <a
              href={getUtmUrl("https://wpmudev.com/", {utm_campaign:'cross-sell_footer-link'})}
              target="_blank"
              className="cross-sell-link"
            >
              {__("WPMU DEV", "plugin-cross-sell-textdomain")}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export { Footer };
